import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from "@angular/forms";
import {
  JaarrapportageEntity,
  ClientEntity,
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BokkzAlgDataService, BokkzJrDataService} from "@snelstart-ventures/fiscaal/domain-logic";
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-winst-en-verliesrekening',
  templateUrl: './winst-en-verliesrekening.component.html',
  imports: [
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    CommonModule
  ],
  styleUrls: ['./winst-en-verliesrekening.component.scss']
})
export class WinstEnVerliesrekeningComponent implements OnInit {

  @Input() public id!: string;
  public client = {} as ClientEntity;
  public JaarrapportageEntity = {} as JaarrapportageEntity;
  public isRechtspersoon = false;
  public year: number | undefined = {} as number;

  public totalNettoOmzetFg = {} as FormGroup;
  public totalWaardeveranderingenVoorraadFg = {} as FormGroup;
  public totalGeactiveerdeProductieEigenBedrijfFg = {} as FormGroup;
  public totalPriveGebruikEigenBedrijfFg = {} as FormGroup;
  public totalExploitatiesubsidiesFg = {} as FormGroup;
  public totalOverigeBedrijfsopbrenstenFg = {} as FormGroup;
  public somBedrijfsopbrengstenFg = {} as FormGroup;
  public somBrutoBedrResFg = {} as FormGroup;

  public totalKostenGrondEnHulpstoffenFg = {} as FormGroup;
  public totalKostenUitbesteedWerkFg = {} as FormGroup;
  public totalLastenPersoneelsbeloningenFg = {} as FormGroup;
  public totalAfschrijvingenIvaMvaFg = {} as FormGroup;
  public totalWaardeveranderingenIvaMvaFg = {} as FormGroup;
  public totalWaardeveranderingenVastgoedbeleggingenFg = {} as FormGroup;
  public totalWaardeveranderingenBeleggingenGerealiseerdFg = {} as FormGroup;
  public totalWaardeveranderingenBeleggingenNietGerealiseerdFg = {} as FormGroup;
  public totalWaardeverminderingVlottendeActivaFg = {} as FormGroup;
  public totalOverigeBedrijfskostenFg = {} as FormGroup;
  public somBedrijfslastenFg = {} as FormGroup;
  public somSomDerKostenFg = {} as FormGroup;
  public somBedrijfsresultaatFg = {} as FormGroup;

  public totalVrijvalUitHerwaarderingsreserveFg = {} as FormGroup;
  public totalFinancieleBatenLastenFg = {} as FormGroup;
  public somResultaatVoorBelastingenFg = {} as FormGroup;
  public totalBelastingenFg = {} as FormGroup;
  public totalResultaatUitDeelnemingenFg = {} as FormGroup;
  public somTotaalResultaatFg = {} as FormGroup;
  public totalOverigeBatenLastenNaBelastingFg = {} as FormGroup;
  public somResultaatNaBelastingenFg = {} as FormGroup;

  constructor(
    public algDataService: BokkzAlgDataService,
    public jrDataService: BokkzJrDataService) {
    this.totalNettoOmzetFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeveranderingenVoorraadFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalGeactiveerdeProductieEigenBedrijfFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalPriveGebruikEigenBedrijfFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalExploitatiesubsidiesFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalOverigeBedrijfsopbrenstenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalKostenGrondEnHulpstoffenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalKostenUitbesteedWerkFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalLastenPersoneelsbeloningenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalAfschrijvingenIvaMvaFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalOverigeBedrijfskostenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeveranderingenIvaMvaFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeveranderingenVastgoedbeleggingenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeveranderingenBeleggingenGerealiseerdFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeveranderingenBeleggingenNietGerealiseerdFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalWaardeverminderingVlottendeActivaFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalVrijvalUitHerwaarderingsreserveFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalFinancieleBatenLastenFg = this.jrDataService.createFormGroupBalanceItem()
    this.somBedrijfsopbrengstenFg = this.jrDataService.createFormGroupBalanceItem()
    this.somBrutoBedrResFg = this.jrDataService.createFormGroupBalanceItem()
    this.somBedrijfslastenFg = this.jrDataService.createFormGroupBalanceItem()
    this.somSomDerKostenFg = this.jrDataService.createFormGroupBalanceItem()
    this.somBedrijfsresultaatFg = this.jrDataService.createFormGroupBalanceItem()
    this.somResultaatVoorBelastingenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalBelastingenFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalResultaatUitDeelnemingenFg = this.jrDataService.createFormGroupBalanceItem()
    this.somTotaalResultaatFg = this.jrDataService.createFormGroupBalanceItem()
    this.totalOverigeBatenLastenNaBelastingFg = this.jrDataService.createFormGroupBalanceItem()
    this.somResultaatNaBelastingenFg = this.jrDataService.createFormGroupBalanceItem()
  }

  ngOnInit(): void {
    this.algDataService.client.subscribe((value) => {
      this.client = value;
    });
    this.jrDataService.isRechtspersoon.subscribe((value) => {
      this.isRechtspersoon = value;
    });
    this.jrDataService.jaarrapportageEntity.subscribe((value) => {
      this.JaarrapportageEntity = value;
      this.year = value.year;
      const venw = value.rapportage?.jaarrekeningen?.at(0)?.winstEnVerliesrekening;
      if (venw) {
        if (venw.nettoOmzet?.netRevenue) {
          this.totalNettoOmzetFg.patchValue(venw.nettoOmzet.netRevenue)
        }
        if (venw.waardeveranderingenVoorraad?.changesInventoriesWorkInProgress) {
          this.totalWaardeveranderingenVoorraadFg.patchValue(venw.waardeveranderingenVoorraad.changesInventoriesWorkInProgress)
        }
        if (venw.geactiveerdeProductieEigenBedrijf?.capitalisedProductionCosts) {
          this.totalGeactiveerdeProductieEigenBedrijfFg.patchValue(venw.geactiveerdeProductieEigenBedrijf.capitalisedProductionCosts)
        }
        if (venw.priveGebruikEigenBedrijf?.privateUseOwnBusiness) {
          this.totalPriveGebruikEigenBedrijfFg.patchValue(venw.priveGebruikEigenBedrijf.privateUseOwnBusiness)
        }
        if (venw.exploitatiesubsidies?.exploitationSubsidies) {
          this.totalExploitatiesubsidiesFg.patchValue(venw.exploitatiesubsidies.exploitationSubsidies)
        }
        if (venw.overigeBedrijfsopbrengsten?.operatingIncomeOther) {
          this.totalOverigeBedrijfsopbrenstenFg.patchValue(venw.overigeBedrijfsopbrengsten.operatingIncomeOther)
        }
        if (venw.bedrijfsopbrengsten?.operatingIncome) {
          this.somBedrijfsopbrengstenFg.patchValue(venw.bedrijfsopbrengsten.operatingIncome)
        }
        if (venw.brutoBedrijfsresultaat?.grossMargin) {
          this.somBrutoBedrResFg.patchValue(venw.brutoBedrijfsresultaat.grossMargin)
        }
        if (venw.kostenGrondEnHulpstoffen?.costsRawMaterialsConsumables) {
          this.totalKostenGrondEnHulpstoffenFg.patchValue(venw.kostenGrondEnHulpstoffen.costsRawMaterialsConsumables)
        }
        if (venw.kostenUitbesteedWerk?.costsOutsourcedWorkOtherExternalExpenses) {
          this.totalKostenUitbesteedWerkFg.patchValue(venw.kostenUitbesteedWerk.costsOutsourcedWorkOtherExternalExpenses)
        }
        if (venw.lastenUitHoofdePersoneelsbeloningen?.employeeBenefitsExpenses) {
          this.totalLastenPersoneelsbeloningenFg.patchValue(venw.lastenUitHoofdePersoneelsbeloningen.employeeBenefitsExpenses)
        }
        if (venw.afschrijvingenIvaMva?.depreciationPropertyPlantEquipmentAmortisationIntangibleAssets) {
          this.totalAfschrijvingenIvaMvaFg.patchValue(venw.afschrijvingenIvaMva.depreciationPropertyPlantEquipmentAmortisationIntangibleAssets)
        }
        if (venw.overigeBedrijfskosten?.operatingExpensesOther) {
          this.totalOverigeBedrijfskostenFg.patchValue(venw.overigeBedrijfskosten.operatingExpensesOther)
        }
        if (venw.overigeWaardeveranderingenIvaMva?.changesInValueIntangibleAssetsPropertyPlantEquipment) {
          this.totalWaardeveranderingenIvaMvaFg.patchValue(venw.overigeWaardeveranderingenIvaMva.changesInValueIntangibleAssetsPropertyPlantEquipment)
        }
        if (venw.waardeveranderingenVastgoedbeleggingen?.changesValueInvestmentProperties) {
          this.totalWaardeveranderingenVastgoedbeleggingenFg.patchValue(venw.waardeveranderingenVastgoedbeleggingen.changesValueInvestmentProperties)
        }
        if (venw.waardeveranderingenBeleggingenGerealiseerd?.realisedChangesInValueOfInvestments) {
          this.totalWaardeveranderingenBeleggingenGerealiseerdFg.patchValue(venw.waardeveranderingenBeleggingenGerealiseerd.realisedChangesInValueOfInvestments)
        }
        if (venw.waardeveranderingenBeleggingenNietGerealiseerd?.unrealisedChangesInValueOfInvestments) {
          this.totalWaardeveranderingenBeleggingenNietGerealiseerdFg.patchValue(venw.waardeveranderingenBeleggingenNietGerealiseerd.unrealisedChangesInValueOfInvestments)
        }
        if (venw.waardeverminderingVlottendeActiva?.impairmentCurrentAssets) {
          this.totalWaardeverminderingVlottendeActivaFg.patchValue(venw.waardeverminderingVlottendeActiva.impairmentCurrentAssets)
        }
        if (venw.bedrijfslasten?.operatingExpenses) {
          this.somBedrijfslastenFg.patchValue(venw.bedrijfslasten.operatingExpenses)
        }
        if (venw.somDerKosten?.sumOfExpenses) {
          this.somSomDerKostenFg.patchValue(venw.somDerKosten.sumOfExpenses)
        }
        if (venw.bedrijfsresultaat?.operatingResult) {
          this.somBedrijfsresultaatFg.patchValue(venw.bedrijfsresultaat.operatingResult)
        }
        if (venw.uitHerwaarderingsreserveVrijgevallenBedragen?.revaluationReserveRelease) {
          this.totalVrijvalUitHerwaarderingsreserveFg.patchValue(venw.uitHerwaarderingsreserveVrijgevallenBedragen.revaluationReserveRelease)
        }
        if (venw.financieleBatenLasten?.financialIncomeExpenses) {
          this.totalFinancieleBatenLastenFg.patchValue(venw.financieleBatenLasten.financialIncomeExpenses)
        }
        if (venw.resultaatVoorBelastingen?.resultBeforeTax) {
          this.somResultaatVoorBelastingenFg.patchValue(venw.resultaatVoorBelastingen.resultBeforeTax)
        }
        if (venw.belastingen?.incomeTaxExpense) {
          this.totalBelastingenFg.patchValue(venw.belastingen.incomeTaxExpense)
        }
        if (venw.aandeelResultaatOndernemingenWaarinWordtDeelgenomen?.shareInResultsParticipatingInterests) {
          this.totalResultaatUitDeelnemingenFg.patchValue(venw.aandeelResultaatOndernemingenWaarinWordtDeelgenomen.shareInResultsParticipatingInterests)
        }
        if (venw.totaalResultaat?.totalResult) {
          this.somTotaalResultaatFg.patchValue(venw.totaalResultaat.totalResult)
        }
        if (venw.overigeBatenLastenNaBelasting?.otherIncomeExpensesAfterTax) {
          this.totalOverigeBatenLastenNaBelastingFg.patchValue(venw.overigeBatenLastenNaBelasting.otherIncomeExpensesAfterTax)
        }
        if (venw.resultaatNaBelastingen?.resultAfterTax) {
          this.somResultaatNaBelastingenFg.patchValue(venw.resultaatNaBelastingen.resultAfterTax)
        }
      }
    });
  }
}
